import { ETransactionTypes } from './types'

export const TransactionDepositTypeFilter = [
  {
    text: ETransactionTypes.TRANSACTION_REQUEST_TYPE_NOVA_SALE,
    value: 'TRANSACTION_REQUEST_TYPE_NOVA_SALE',
  },
  {
    text: ETransactionTypes.TRANSACTION_REQUEST_TYPE_NOVA_DEPOSIT,
    value: 'TRANSACTION_REQUEST_TYPE_NOVA_DEPOSIT',
  },
  {
    text: ETransactionTypes.TRANSACTION_REQUEST_TYPE_DEPOSIT,
    value: 'TRANSACTION_REQUEST_TYPE_DEPOSIT',
  },
]
